<template>
  <div class="l-header-body">
    <div class="l-header-body__inner">
      <div class="l-header-logo">
        <div class="sitelogo">
          <router-link :to="{ name: 'top' }" name="S2-3-home-btn">
            <img src="@/styles/img/common/img_logo.svg" alt="MANAVIRIA">
          </router-link>
        </div>
        <div class="l-header-info -alert">
          <a href="javascript:void(0)" @click="emit('next-grade')" class="l-header-info-class" v-if="nextGradeStore.classroom_list.length>0">学級・出席番号を設定</a>
          <p class="l-header-info-class" v-else>{{accountStore.studentProfile.profile.classroom.name}} {{accountStore.studentProfile.profile.number}}</p>
          <p class="l-header-info-name"><span class="name">{{accountStore.studentProfile.profile.name}}</span><span class="title">さん</span></p>
        </div>
        <div class="character">
          <img
              srcset="@/styles/img/common/img_character.png 1x, @/styles/img/common/img_character@2x.png 2x"
              src="@/styles/img/common/img_character.png"
              alt=""
          >
          <div class="missionScore">
            <div class="missionScore__column">
              <span class="label">今日のクリア<br><span class="label__large">ミッション</span></span>
            </div>
            <div class="missionScore__column">
              <span class="num">
                <span ref="refClearCountNum" class="num__text">{{clearCount}}</span>
                <span class="num__deco"></span>
              </span>
            </div>
          </div>
          <div class="character__hands">
            <img
                srcset="@/styles/img/common/img_character_hands_new.png 1x, @/styles/img/common/img_character_hands_new@2x.png 2x"
                src="@/styles/img/common/img_character_hands_new.png"
                alt=""
            >
          </div>
        </div>
      </div>

      <div class="l-header-scroll-area">
        <div class="l-header-scroll-area__inner">

          <div v-if="!accountGlobalMenu" class="subjectNav">
            <ul class="subjectNav__list">
              <li :class="{'subjectNav__list__item':true, 'subjectNav__list__item--homework':true}">
                <router-link :to="{ name: 'current-homework' }" name="S2-3-homework-btn">
                  <span class="label">宿題</span><span class="badge" v-if="numberOfHomeworks>0">{{ numberOfHomeworks }}</span>
                </router-link>
              </li>
              <li :class="{'subjectNav__list__item':true, 'subjectNav__list__item--mission':true}"  v-if="licensedSubject.length">
                <router-link :to="{ name: 'mission' }" name="S2-3-mission-btn">
                  <span class="label">ミッション</span>
                </router-link>
              </li>
              <li v-for="(subj, i) in licensedSubjectForNav" :key="i"
                  :class="{'subjectNav__list__item':true, [`subjectNav__list__item--${subjectMap[subj.name]}`]:true}">
                <router-link :to="{ name: 'work', params: { work_id: subjectMap[subj.name] }}" :name="`S2-3-${subjectMap[subj.name]}-btn`">
                  <span class="label">{{ subj.name }}</span>
                </router-link>
              </li>
            </ul>
          </div>

          <div v-else class="accountNav">
            <ul class="accountNav__list">
              <li class="accountNav__list__item accountNav__list__item--acInfo">
                <router-link :to="{ name: 'notice', params: { page_number: '1' } }" name="S2-3-notice-btn">
                  <span class="label">お知らせ<icon-notification :is-account="true"  :number-of-notification="numberOfNotification>9?9:numberOfNotification" v-if="numberOfNotification">{{numberOfNotification>9?'+':''}}</icon-notification></span>
                </router-link>
              </li>
              <li class="accountNav__list__item accountNav__list__item--acStatus">
                <router-link :to="{ name: 'learning-status'}" name="S2-3-learning-status-btn">
                  <span class="label">学習状況</span>
                </router-link>
              </li>
              <li class="accountNav__list__item accountNav__list__item--acAccount">
                <router-link :to="{ name: 'account'}" name="S2-3-account-btn">
                  <span class="label">アカウント情報</span>
                </router-link>
              </li>
              <li class="accountNav__list__item accountNav__list__item--acReader">
                <router-link :to="{ name: 'setting'}" name="S2-3-setting-btn">
                  <span class="label">各種設定</span>
                </router-link>
              </li>
              <li class="accountNav__list__item accountNav__list__item--acVersion">
                <router-link :to="{ name: 'version'}" name="S2-3-version-btn">
                  <span class="label">バージョン情報/<br>利用期限</span>
                </router-link>
              </li>
            </ul>
          </div>

          <div class="statusNav">
            <ul class="statusNav__list">
              <li class="statusNav__list__item statusNav__list__item--badge hideRelease1">
                <a>
                  <span class="label">
                    <span class="label__text">{{numberOfBadges}}</span>
                  </span>
                </a>
              </li>
              <li class="statusNav__list__item statusNav__list__item--star" v-if="!accountGlobalMenu">
                <router-link :to="{ name: 'learning-status'}" name="S2-3-learning-status-btn">
                  <span class="label">
                    <span ref="refStarCountNum" class="label__text">{{starCount}}</span>
                  </span>
                </router-link>
              </li>
            </ul>
          </div>

          <div class="settingNav">
            <ul class="settingNav__list">
              <li v-if="!accountGlobalMenu" class="settingNav__list__item">
                <router-link :to="{ name: 'notice', params: { page_number: '1' } }" @click.native="savePreviousSelectedMenu" name="S2-3-setting-btn">
                  <icon-notification :is-setting="true" :number-of-notification="numberOfNotification>9?9:numberOfNotification" v-if="numberOfNotification">{{numberOfNotification>9?'+':''}}</icon-notification>
                  <span class="icon icon--setting"></span>
                </router-link>
              </li>
              <li class="settingNav__list__item">
                <a @click="emit('help')" name="S2-3-help-btn">
                  <span class="icon icon--quest"></span>
                </a>
              </li>
            </ul>
          </div>
          <ul class="c-link -header" v-if="accountGlobalMenu">
            <li class="c-link__item -faq">
              <a href="https://www.meijitosho.co.jp/gakusan/manaviria/help/student/faq/" target="_blank">よくある質問</a>
            </li>
            <li class="c-link__item -contact">
              <a href="https://manavi.wikipy.jp/student/p432" target="_blank">ご意見投稿</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, onUnmounted} from "vue";
  import {SUBJECT_MAP} from "@/consts/subject";
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import {useAccountStore } from '@/store/student/account_store';
  import { useNextGradeStore } from '@/store/student/next_grade';

  const globalNavigationStore = useGlobalNavigationStore()
  const accountStore = useAccountStore()
  const nextGradeStore = useNextGradeStore()
  const subjectMap = ref(SUBJECT_MAP)
  const refresh_animation_timer = ref(null)
  const refresh_star_timer = ref(null)
  const refStarCountNum = ref(null)
  const refClearCountNum = ref(null)
  const props = withDefaults(
    defineProps<{
      accountGlobalMenu: boolean;
      numberOfNotification: number;
      licensedSubject: Array<any>;
      licensedSubjectForNav: Array<any>;
      clearCount?: number;
      starCount?: number;
      numberOfHomeworks?: number;
      numberOfStars?: number;
      numberOfBadges?: number;
    }>(),
    {
      clearCount: 0,
      starCount: 0,
      numberOfHomeworks: 0,
      numberOfStars: 0,
      numberOfBadges: 0,
    }
  );

  const emit = defineEmits<{
    (e: 'update-clear-count', id: any): void,
    (e: 'update-star-count', id: any): void,
    (e: 'help'): void,
    (e: 'next-grade'): void,
  }>()

  function savePreviousSelectedMenu(){
    globalNavigationStore.savePrevSelectedMenu(globalNavigationStore.selectedMenu)
  }

  function animateClearCount(time) {
    return new Promise((resolve, reject) => {
      let speed = 40;
      let clear = refClearCountNum.value
      let clearCountNum = props.clearCount
      let updateClearCountNum = clearCountNum + 1
      refresh_animation_timer.value = setTimeout(() => {
        let id = setInterval(function () {
          clear.innerText = clearCountNum
          if (clearCountNum == updateClearCountNum) {
            clearInterval(id)
            emit('update-clear-count', clearCountNum)
            resolve(true)
          }
          if (clearCountNum < updateClearCountNum) {
            clearCountNum++;
          }
        }, speed);
      }, time);
    })
  }

  function animateStarCount(time) {
    return new Promise((resolve, reject) => {
      let speed = 100;
      let star = refStarCountNum.value
      let starCountNum = props.starCount
      let updateStarCountNum = starCountNum + Number(props.numberOfStars)
      refresh_star_timer.value = setTimeout(() => {
        let id = setInterval(function () {
          star.innerText = starCountNum
          if (starCountNum == updateStarCountNum) {
            clearInterval(id)
            emit('update-star-count', starCountNum)
            resolve(true)
          }
          if (starCountNum < updateStarCountNum) {
            starCountNum++;
          }
        }, speed);
      }, time);
    })
  }
  onUnmounted(() => {
    clearTimeout(refresh_animation_timer.value);
    clearTimeout(refresh_star_timer.value);
  });
  defineExpose({
    animateStarCount,
    animateClearCount,
  })
</script>

<style lang="scss" scoped>
// リリース1で非表示する部分のため設定
.hideRelease1{
  display: none;
}
</style>
